import React, { useEffect, useState } from 'react';
import { Button, useConfirmationModal } from 'LocalGluons';
import MirroringPreventDialog from 'LocalGluons/components/PlayerContainer/components/MirroringPreventDialog'; import { useStore } from 'Store';
import useMirroringCheck from 'LocalGluons/components/PlayerContainer/hooks/useMirroringCheck';
import detailStyles from '../../Details.jss';
import { t } from '../../../../../locale';

interface TrailerButtonProps {
    onPress: () => void;
    testID?: string
}

const TrailerButton = ({ onPress = () => { }, testID }: TrailerButtonProps) => {
    const { setPlayerData } = useStore();
    const { setModalContent } = useConfirmationModal();
    const { getIsMirroring } = useMirroringCheck();

    const onClose = () => {
        setPlayerData(null);
        setModalContent(null);

    };
    return (
        <Button
            style={{
                button: detailStyles.button,
                text: detailStyles.text,
                icon: detailStyles.playIcon
            }}
            isSecondary
            iconName="play_arrow_player"
            title={t('COMMON.TRAILER')}
            onPress={async () => {
                const isMirroring = await getIsMirroring();
                if (isMirroring) {
                    setModalContent(
                        <MirroringPreventDialog
                            setModalContent={setModalContent}
                            onClose={((onClose))} />
                    );
                } else {
                    onPress();
                }
            }}
        />
    );
};

export default TrailerButton;
